// extracted by mini-css-extract-plugin
export default {"titleRow":"NewsList-module--titleRow--Xlrru","title":"NewsList-module--title--g+K5y","list":"NewsList-module--list--93CMG","listWrapper":"NewsList-module--listWrapper--BVLmq"};